import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import NewsBody from "./newsBody";

function News(){
    return(
       
    <div className="News" style={{backgroundColor: "black"}}>
       <Navbar/>
<NewsBody/>
<Footer/>

        </div>

    )
}
export default News;